module.exports = __webpack_public_path__ + "media/images/what_can_do_2-2fd8023d1d032a3f30e8e2827490750c.svg";